import { useContext } from 'react';
import FormPlayerContext from 'components/video/edit/Form/Player/PlayerContext';

export function usePlayer() {
    const { player, timeOnSeek } = useContext(FormPlayerContext);
    return { ...player, timeOnSeek };
}
